import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../assets/css/app.css";
import "../assets/css/custom.css";
import "../assets/css/responsive.css";
import { API_BASE_URL, Image_URL, Web_Image_URL } from "../config";
import Currency from "./Currency";

const Headerwithoutmenu = () => {
  const [user, setUser] = useState("");
  const [menuData, setMenuData] = useState([]);
  const [active, setActive] = useState(
    localStorage.getItem("activeView") || "wholesale"
  );

  // Mobile navigation state
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileOpenCategory, setMobileOpenCategory] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    // FIX: this used to run ONCE on mount only, so Header kept showing
    // whichever user was logged in when it first mounted — even after
    // that user logged out, or a different user logged in afterward,
    // if Header itself doesn't get remounted by the route change.
    // Now it also re-runs whenever localStorage's "user" key changes,
    // via the "storage" event dispatched by Login.js on login and by
    // handleLogout below on logout.
    const loadUserFromStorage = () => {
      const storedUser = localStorage.getItem("user");

      if (storedUser) {
        try {
          const userObj = JSON.parse(storedUser);
          setUser(userObj);

          let type = userObj?.customerType?.toLowerCase();
          let savedView = localStorage.getItem("activeView");

          if (!savedView) {
            savedView = type === "retail" ? "retail" : "wholesale";
            localStorage.setItem("activeView", savedView);
          }

          setActive(savedView);
          applyMarkupFetch(savedView);
        } catch {
          // corrupt cache — treat as logged out
          setUser("");
        }
      } else {
        // logged out / cleared — reset Header's own copy too
        setUser("");
      }
    };

    loadUserFromStorage();

    // Native "storage" only fires for changes made in OTHER tabs; same-tab
    // changes (this browser tab logging in/out) need a manually dispatched
    // Event("storage") — Login.js and handleLogout below both do this.
    window.addEventListener("storage", loadUserFromStorage);

    // Fetch Menu Data
    fetch(`${API_BASE_URL}/Menu/GetMenuSubmenu`)
      .then((res) => res.json())
      .then((result) => {
        if (result.success && Array.isArray(result.data)) {
          const grouped = result.data.reduce((acc, item) => {
            const {
              CategoryId,
              CategoryName,
              StyleId,
              StyleName,
              ShapeId,
              ShapeName,
              DiamondId,
              DiamondName,
            } = item;

            if (!acc[CategoryId]) {
              acc[CategoryId] = {
                categoryId: CategoryId,
                categoryName: CategoryName,
                subcategories: {},
              };
            }

            if (StyleId && StyleName) {
              if (!acc[CategoryId].subcategories[StyleId]) {
                acc[CategoryId].subcategories[StyleId] = {
                  id: StyleId,
                  name: StyleName,
                  shapes: [],
                  diamonds: [],
                };
              }

              if (ShapeId && ShapeName) {
                acc[CategoryId].subcategories[StyleId].shapes.push({
                  id: ShapeId,
                  name: ShapeName,
                });
              }

              if (DiamondId && DiamondName) {
                acc[CategoryId].subcategories[StyleId].diamonds.push({
                  id: DiamondId,
                  name: DiamondName,
                });
              }
            }

            return acc;
          }, {});

          const structuredData = Object.values(grouped).map((cat) => ({
            ...cat,
            subcategories: Object.values(cat.subcategories),
          }));

          setMenuData(structuredData);
        }
      })
      .catch((err) => console.error("Error fetching menu data:", err));

    return () => {
      window.removeEventListener("storage", loadUserFromStorage);
    };
  }, []);

  // Fetch markup % table
  const applyMarkupFetch = async (view) => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const companyId = storedUser?.companyId || 0;

    if (!companyId) {
      console.warn("⚠️ No companyId found in user data.");
      return;
    }

    if (view === "retail" || view === "wholesale") {
      try {
        const response = await fetch(
          `${API_BASE_URL}/Order/GetPriceTable?companyId=${companyId}`
        );

        const result = await response.json();

        if (result?.status === 200 && Array.isArray(result.data)) {
          const allData = result.data;
          const sellerData = allData.slice(0, 8);

          localStorage.setItem(
            "priceTable_seller",
            JSON.stringify({
              data: sellerData,
              savedAt: Date.now(),
            })
          );
        } else {
          console.warn("⚠️ No markup data found in response");
        }
      } catch (err) {
        console.error("❌ Error fetching markup table:", err);
      }
    } else {
      localStorage.removeItem("priceTable_seller");
    }

    window.dispatchEvent(new Event("storage"));
  };

  // Handle View Change
  const handleViewChange = (view) => {
    setActive(view);
    localStorage.setItem("activeView", view);

    applyMarkupFetch(view);

    window.dispatchEvent(new Event("storage"));

    window.dispatchEvent(
      new CustomEvent("viewChange", {
        detail: view,
      })
    );
  };

  // const handleLogout_old = () => {
  //   localStorage.clear();
  //   setUser(null);

  //   setMobileMenuOpen(false);
  //   setMobileOpenCategory(null);

  //   navigate("/");
  // };
const handleLogout = async () => {
  try {
    await fetch(`${API_BASE_URL}/Home/Logout`, {
      method: "POST",
      credentials: "include", // zaroori — cross-domain Set-Cookie (delete) accept karne ke liye
    });
  } catch (err) {
    console.error("Logout API failed", err);
    // API fail ho bhi jaye, tab bhi client-side clear karo taki user stuck na feel kare
  }

  localStorage.clear();       // sab kuch clear — user, priceTable, activeView, etc.
  sessionStorage.clear();
  setUser("");
  setMobileMenuOpen(false);
  setMobileOpenCategory(null);

  // FIX: reset tab title/icon back to default — otherwise the previous
  // company's name/logo stays in the browser tab after logout. Remove +
  // recreate the <link> node (not just set .href) since some browsers
  // cache the tab icon against the existing node and won't repaint on a
  // plain href change.
  document.title = "West End Jewellery";
  document
    .querySelectorAll("link[rel='shortcut icon'], link[rel='icon']")
    .forEach((el) => el.remove());
  const newFavicon = document.createElement("link");
  newFavicon.rel = "shortcut icon";
  newFavicon.type = "image/x-icon";
  newFavicon.href = "/assets/img/West-End-Jewelry-Logo1.png";
  document.head.appendChild(newFavicon);

  // FIX: tell every Header instance (and anything else listening) that
  // storage changed, so they reset immediately even without remounting.
  window.dispatchEvent(new Event("storage"));

  navigate("/");
};
  // Close mobile menu
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setMobileOpenCategory(null);
  };

  // Toggle mobile category
  const toggleMobileCategory = (categoryId) => {
    setMobileOpenCategory((current) =>
      current === categoryId ? null : categoryId
    );
  };

  const preferredOrder = [
    "Engagement Rings",
    "Wedding Rings",
    "Fashion Rings",
    "Earrings",
    "Pendants",
    "Bracelets",
  ];

  return (
    <header id="site-header" className="site-header header-v3">

      {/* ============================================================
          DESKTOP HEADER
          Existing desktop header remains unchanged
          ============================================================ */}

      <div className="header-desktop">

        {/* Header Top */}
        <div className="header-top">
          <div className="section-padding">
            <div className="section-container large p-l-r">
              <div className="row">

                {/* Left */}
                <div className="col-xl-2 col-lg-4 col-md-12 header-left"></div>

                {/* Center Logo */}
                <div className="col-xl-7 col-lg-4 col-md-12 text-center header-center">
                  <div className="site-logo">
                    <a href="/">
                      <img
                        width="400"
                        height="80"
                        src={
                          user?.companyLogo
                            ? `${Image_URL}Companylogo/${user.companyLogo}`
                            : `${Web_Image_URL}img/West-End-Jewellery-Logo.png`
                        }
                        alt={user?.companyname || "West End Jewellery"}
                      />
                    </a>
                  </div>
                </div>

                {/* Right */}
                <div className="col-xl-3 col-lg-4 col-md-12 header-right">
                  <div
                    className="header-page-link"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >

                    <div
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                      }}
                    >

                      {/* Wholesale */}
                      {(user?.customerType?.toLowerCase() === "wholesale" ||
                        user?.customerType?.toLowerCase() === "both") && (
                        <button
                          onClick={() => handleViewChange("wholesale")}
                          style={{
                            backgroundColor:
                              active === "wholesale"
                                ? "#a0989821"
                                : "#fff",
                            border:
                              active === "wholesale"
                                ? "2px solid #a0989821"
                                : "1px solid #ccc",
                            fontWeight:
                              active === "wholesale" ? "bold" : "normal",
                            marginRight: "5px",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Wholesale
                        </button>
                      )}

                      {/* Retail */}
                      {(user?.customerType?.toLowerCase() === "retail" ||
                        user?.customerType?.toLowerCase() === "both") && (
                        <button
                          onClick={() => handleViewChange("retail")}
                          style={{
                            backgroundColor:
                              active === "retail"
                                ? "#a0989821"
                                : "#fff",
                            border:
                              active === "retail"
                                ? "2px solid #a0989821"
                                : "1px solid #ccc",
                            fontWeight:
                              active === "retail" ? "bold" : "normal",
                            marginRight: "5px",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Retail
                        </button>
                      )}
                    </div>

                    {user && (
                      <>
                        <div style={{ marginBottom: "10px" }}>
                          <Currency />
                        </div>

                        <div style={{ marginBottom: "10px" }}>
                          <Link
                            style={{
                              backgroundColor: "#fff",
                              borderColor: "#ccc",
                              padding: "8px 8px",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            to="/wishlist"
                          >
                            Wishlist
                          </Link>
                        </div>

                        <div style={{ marginBottom: "10px" }}>
                          <Link
                            style={{
                              backgroundColor: "#fff",
                              borderColor: "#ccc",
                              padding: "8px 8px",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            to="/cart"
                          >
                            Cart
                          </Link>
                        </div>

                        <div style={{ marginBottom: "10px" }}>
                          <button
                            style={{
                              backgroundColor: "#fff",
                              borderColor: "#ccc",
                              padding: "5px 5px",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ============================================================
            DESKTOP NAVIGATION
            ============================================================ */}

        <div className="header-middle text-center color-white">
          <div className="site-navigation">
            <nav id="main-navigation">
              <ul id="menu-main-menu" className="menu">

                {/* Dynamic Categories */}

                {menuData
                  ?.filter((cat) => cat && cat.categoryName)
                  .sort((a, b) => {
                    const indexA = preferredOrder.indexOf(
                      a.categoryName.trim()
                    );

                    const indexB = preferredOrder.indexOf(
                      b.categoryName.trim()
                    );

                    if (indexA !== -1 && indexB !== -1) {
                      return indexA - indexB;
                    }

                    if (indexA !== -1) return -1;
                    if (indexB !== -1) return 1;

                    return a.categoryName.localeCompare(b.categoryName);
                  })
                  .map((cat) => (
                    <li
                      key={cat.categoryId}
                      className={`level-0 menu-item ${
                        cat.subcategories.length
                          ? "menu-item-has-children"
                          : ""
                      }`}
                    >

                      <Link
                        to={`/products?category=${encodeURIComponent(
                          cat.categoryName
                        )}`}
                      >
                        <span className="menu-item-text">
                          {cat.categoryName}
                        </span>
                      </Link>

                      {cat.subcategories.length > 0 && (
                        <ul
                          className="sub-menu mega-menu"
                          style={{ display: "flex" }}
                        >

                          {/* Styles */}

                          <li
                            className="menu-item mega-column"
                            style={{ flex: 1 }}
                          >
                            <h4 className="mega-title">
                              {cat.categoryName} Style
                            </h4>

                            <div
                              className="style-list"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                              }}
                            >

                              {cat.subcategories
                                .sort((a, b) => {
                                  const category =
                                    cat.categoryName.trim();

                                  let preferredStyleOrder = [];

                                  if (
                                    category === "Engagement Rings"
                                  ) {
                                    preferredStyleOrder = [
                                      "solitaire",
                                      "three stone",
                                      "side stone",
                                      "halo",
                                    ];
                                  } else if (
                                    category === "Wedding Rings"
                                  ) {
                                    preferredStyleOrder = [
                                      "5 stone",
                                      "7 stone",
                                      "9 stone",
                                      "11 stone",
                                      "channel",
                                      "shared prong",
                                      "contour band",
                                      "fancy bands",
                                      "eternity",
                                    ];
                                  } else if (
                                    category === "Earrings"
                                  ) {
                                    preferredStyleOrder = [
                                      "solitaire stud",
                                      "cluster",
                                      "halo",
                                      "hoop",
                                      "dangle",
                                      "fashion earring",
                                    ];
                                  } else if (
                                    category === "Pendants"
                                  ) {
                                    preferredStyleOrder = [
                                      "solitaire",
                                      "cluster",
                                      "halo",
                                      "heart",
                                      "circle",
                                      "cross",
                                      "bar",
                                      "tree of life",
                                      "journey",
                                    ];
                                  }

                                  if (
                                    preferredStyleOrder.length > 0
                                  ) {
                                    const indexA =
                                      preferredStyleOrder.indexOf(
                                        a.name
                                          .trim()
                                          .toLowerCase()
                                      );

                                    const indexB =
                                      preferredStyleOrder.indexOf(
                                        b.name
                                          .trim()
                                          .toLowerCase()
                                      );

                                    if (
                                      indexA !== -1 &&
                                      indexB !== -1
                                    ) {
                                      return indexA - indexB;
                                    }

                                    if (indexA !== -1) return -1;
                                    if (indexB !== -1) return 1;
                                  }

                                  return a.name.localeCompare(
                                    b.name
                                  );
                                })
                                .map((sub) => (
                                  <Link
                                    key={sub.id}
                                    to={`/products?category=${encodeURIComponent(
                                      cat.categoryName
                                    )}&style=${encodeURIComponent(
                                      sub.name
                                    )}`}
                                  >
                                    <img
                                      style={{ width: 35 }}
                                      src={`https://westendjewellery.com/assets/img/${cat.categoryName
                                        .trim()
                                        .replace(/\s+/g, "")
                                        .toLowerCase()}${sub.name
                                        .trim()
                                        .replace(/\s+/g, "")
                                        .toLowerCase()}.png`}
                                      alt={sub.name}
                                      className="shape-icon"
                                    />

                                    <span>{sub.name}</span>
                                  </Link>
                                ))}

                            </div>
                          </li>

                          {/* Shapes */}

                          <li
                            className="menu-item mega-column"
                            style={{ flex: 1 }}
                          >
                            <h4 className="mega-title">
                              Shop by Shape
                            </h4>

                            <div
                              className="shape-grid"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                              }}
                            >

                              {Array.from(
                                new Map(
                                  cat.subcategories
                                    .flatMap(
                                      (sub) => sub.shapes || []
                                    )
                                    .map((shape) => [
                                      shape.id,
                                      shape,
                                    ])
                                ).values()
                              )
                                .sort((a, b) =>
                                  a.name.localeCompare(b.name)
                                )
                                .map((shape) => (
                                  <Link
                                    key={shape.id}
                                    to={`/products?category=${encodeURIComponent(
                                      cat.categoryName
                                    )}&shape=${encodeURIComponent(
                                      shape.name
                                    )}`}
                                  >
                                    <img
                                      style={{ width: 35 }}
                                      src={`https://westendjewellery.com/assets/img/shape/${shape.name
                                        .trim()
                                        .replace(/\s+/g, "")
                                        .toLowerCase()}.png`}
                                      alt={shape.name}
                                      className="shape-icon"
                                    />

                                    <span>{shape.name}</span>
                                  </Link>
                                ))}

                            </div>
                          </li>

                          {/* Diamonds */}

                          <li
                            className="menu-item mega-column"
                            style={{ flex: 1 }}
                          >
                            <h4 className="mega-title">
                              Diamond Type
                            </h4>

                            <div
                              className="shape-grid"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                              }}
                            >

                              {Array.from(
                                new Map(
                                  cat.subcategories
                                    .flatMap(
                                      (sub) => sub.diamonds || []
                                    )
                                    .map((diamond) => [
                                      diamond.id,
                                      diamond,
                                    ])
                                ).values()
                              ).map((diamond) => (
                                <Link
                                  key={diamond.id}
                                  to={`/products?category=${encodeURIComponent(
                                    cat.categoryName
                                  )}&diamond=${encodeURIComponent(
                                    diamond.name
                                  )}`}
                                >
                                  <img
                                    style={{ width: 30 }}
                                    src="https://westendjewellery.com/assets/img/DIAMOND.png"
                                    alt={diamond.name}
                                    className="shape-icon"
                                  />

                                  <span>{diamond.name}</span>
                                </Link>
                              ))}

                            </div>
                          </li>

                          {/* Metals */}

                          <li
                            className="menu-item mega-column"
                            style={{ flex: 1 }}
                          >
                            <h4 className="mega-title">
                              Metal Type
                            </h4>

                            <div
                              className="shape-grid"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                              }}
                            >

                              {[
                                "Yellow Gold",
                                "Rose Gold",
                                "White Gold",
                              ].map((metal) => (
                                <Link
                                  key={metal}
                                  to={`/products?category=${encodeURIComponent(
                                    cat.categoryName
                                  )}&metal=${encodeURIComponent(
                                    metal
                                  )}`}
                                >
                                  <img
                                    style={{ width: 30 }}
                                    src={`https://westendjewellery.com/assets/img/${metal
                                      .replace(/\s+/g, "")
                                      .toLowerCase()}.png`}
                                    alt={metal}
                                    className="shape-icon"
                                  />

                                  <span>{metal}</span>
                                </Link>
                              ))}

                            </div>
                          </li>

                        </ul>
                      )}

                    </li>
                  ))}

                {/* All */}

                <li className="level-0 menu-item">
                  <Link to="/products">
                    <span className="menu-item-text">
                      All
                    </span>
                  </Link>
                </li>

                {/* Dashboard */}

                <li className="level-0 menu-item">
                  <Link to="/partnerdashboard">
                    <span className="menu-item-text">
                      Dashboard
                    </span>
                  </Link>
                </li>

                {/* Stock */}

                <li className="level-0 menu-item">
                  <Link to="/stockandcarry">
                    <span className="menu-item-text">
                      Stock On Hand
                    </span>
                  </Link>
                </li>

                {/* About */}

                <li className="level-0 menu-item">
                  <Link to="/about">
                    <span className="menu-item-text">
                      About US
                    </span>
                  </Link>
                </li>

                {/* Login / Register */}

                {(!user || Object.keys(user).length === 0) && (
                  <>
                    <li className="level-0 menu-item">
                      <Link to="/Login">
                        <span className="menu-item-text">
                          Log In
                        </span>
                      </Link>
                    </li>

                    <li className="level-0 menu-item">
                      <Link to="/registration">
                        <span className="menu-item-text">
                          Sign Up
                        </span>
                      </Link>
                    </li>
                  </>
                )}

              </ul>
            </nav>
          </div>
        </div>

      </div>

      {/* ============================================================
          MOBILE HEADER
          Completely separate from desktop header
          ============================================================ */}

      <div className="wej-mobile-header">

        {/* Mobile Top Bar */}

        <div className="wej-mobile-header-inner">

          <Link
            to="/"
            className="wej-mobile-logo"
            onClick={closeMobileMenu}
            aria-label="West End Jewellery Home"
          >
            <img
              src={
                user?.companyLogo
                  ? `${Image_URL}Companylogo/${user.companyLogo}`
                  : `${Web_Image_URL}img/West-End-Jewellery-Logo.png`
              }
              alt={
                user?.companyname || "West End Jewellery"
              }
            />
          </Link>

          {/* Hamburger */}

          <button
            type="button"
            className={`wej-mobile-menu-button ${
              mobileMenuOpen
                ? "wej-mobile-menu-button-open"
                : ""
            }`}
            onClick={() =>
              setMobileMenuOpen(
                (current) => !current
              )
            }
            aria-label={
              mobileMenuOpen
                ? "Close navigation menu"
                : "Open navigation menu"
            }
            aria-expanded={mobileMenuOpen}
            aria-controls="wej-mobile-navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>

        {/* Mobile Drawer */}

        <div
          id="wej-mobile-navigation"
          className={`wej-mobile-drawer ${
            mobileMenuOpen
              ? "wej-mobile-drawer-open"
              : ""
          }`}
        >

          <div className="wej-mobile-drawer-scroll">

            <nav
              className="wej-mobile-nav"
              aria-label="Mobile navigation"
            >

              {/* All */}

              <Link
                to="/products"
                className="wej-mobile-main-link"
                onClick={closeMobileMenu}
              >
                All
              </Link>

              {/* Dynamic Categories */}

              {menuData
                ?.filter(
                  (cat) =>
                    cat && cat.categoryName
                )
                .sort((a, b) => {
                  const indexA =
                    preferredOrder.indexOf(
                      a.categoryName.trim()
                    );

                  const indexB =
                    preferredOrder.indexOf(
                      b.categoryName.trim()
                    );

                  if (
                    indexA !== -1 &&
                    indexB !== -1
                  ) {
                    return indexA - indexB;
                  }

                  if (indexA !== -1) return -1;
                  if (indexB !== -1) return 1;

                  return a.categoryName.localeCompare(
                    b.categoryName
                  );
                })
                .map((cat) => {

                  const isOpen =
                    mobileOpenCategory ===
                    cat.categoryId;

                  // Style ordering
                  const preferredStyleOrder =
                    (() => {
                      const category =
                        cat.categoryName.trim();

                      if (
                        category ===
                        "Engagement Rings"
                      ) {
                        return [
                          "solitaire",
                          "three stone",
                          "side stone",
                          "halo",
                        ];
                      }

                      if (
                        category ===
                        "Wedding Rings"
                      ) {
                        return [
                          "5 stone",
                          "7 stone",
                          "9 stone",
                          "11 stone",
                          "channel",
                          "shared prong",
                          "contour band",
                          "fancy bands",
                          "eternity",
                        ];
                      }

                      if (
                        category ===
                        "Earrings"
                      ) {
                        return [
                          "solitaire stud",
                          "cluster",
                          "halo",
                          "hoop",
                          "dangle",
                          "fashion earring",
                        ];
                      }

                      if (
                        category ===
                        "Pendants"
                      ) {
                        return [
                          "solitaire",
                          "cluster",
                          "halo",
                          "heart",
                          "circle",
                          "cross",
                          "bar",
                          "tree of life",
                          "journey",
                        ];
                      }

                      return [];
                    })();

                  const sortedSubcategories =
                    [
                      ...(cat.subcategories ||
                        []),
                    ].sort((a, b) => {

                      if (
                        preferredStyleOrder.length >
                        0
                      ) {
                        const indexA =
                          preferredStyleOrder.indexOf(
                            a.name
                              .trim()
                              .toLowerCase()
                          );

                        const indexB =
                          preferredStyleOrder.indexOf(
                            b.name
                              .trim()
                              .toLowerCase()
                          );

                        if (
                          indexA !== -1 &&
                          indexB !== -1
                        ) {
                          return (
                            indexA - indexB
                          );
                        }

                        if (indexA !== -1)
                          return -1;

                        if (indexB !== -1)
                          return 1;
                      }

                      return a.name.localeCompare(
                        b.name
                      );
                    });

                  // Unique shapes
                  const shapes =
                    Array.from(
                      new Map(
                        (
                          cat.subcategories ||
                          []
                        )
                          .flatMap(
                            (sub) =>
                              sub.shapes || []
                          )
                          .map((shape) => [
                            shape.id,
                            shape,
                          ])
                      ).values()
                    ).sort((a, b) =>
                      a.name.localeCompare(
                        b.name
                      )
                    );

                  // Unique diamonds
                  const diamonds =
                    Array.from(
                      new Map(
                        (
                          cat.subcategories ||
                          []
                        )
                          .flatMap(
                            (sub) =>
                              sub.diamonds ||
                              []
                          )
                          .map((diamond) => [
                            diamond.id,
                            diamond,
                          ])
                      ).values()
                    );

                  const metals = [
                    "Yellow Gold",
                    "Rose Gold",
                    "White Gold",
                  ];

                  return (
                    <div
                      key={cat.categoryId}
                      className={`wej-mobile-category ${
                        isOpen
                          ? "wej-mobile-category-open"
                          : ""
                      }`}
                    >

                      {/* Category Header */}

                      <div className="wej-mobile-category-row">

                        <Link
                          to={`/products?category=${encodeURIComponent(
                            cat.categoryName
                          )}`}
                          className="wej-mobile-category-link"
                          onClick={
                            closeMobileMenu
                          }
                        >
                          {cat.categoryName}
                        </Link>

                        {cat.subcategories
                          ?.length >
                          0 && (
                          <button
                            type="button"
                            className="wej-mobile-category-toggle"
                            onClick={() =>
                              toggleMobileCategory(
                                cat.categoryId
                              )
                            }
                            aria-label={`Toggle ${cat.categoryName} submenu`}
                            aria-expanded={
                              isOpen
                            }
                          >
                            <span></span>
                            <span></span>
                          </button>
                        )}

                      </div>

                      {/* Category Dropdown */}

                      {cat.subcategories
                        ?.length > 0 && (
                        <div
                          className={`wej-mobile-submenu ${
                            isOpen
                              ? "wej-mobile-submenu-open"
                              : ""
                          }`}
                        >

                          <div className="wej-mobile-submenu-inner">

                            {/* Styles */}

                            <div className="wej-mobile-subsection">

                              <div className="wej-mobile-subsection-title">
                                {cat.categoryName}{" "}
                                Style
                              </div>

                              {sortedSubcategories.map(
                                (sub) => (
                                  <Link
                                    key={sub.id}
                                    to={`/products?category=${encodeURIComponent(
                                      cat.categoryName
                                    )}&style=${encodeURIComponent(
                                      sub.name
                                    )}`}
                                    className="wej-mobile-sub-link"
                                    onClick={
                                      closeMobileMenu
                                    }
                                  >

                                    <img
                                      src={`https://westendjewellery.com/assets/img/${cat.categoryName
                                        .trim()
                                        .replace(
                                          /\s+/g,
                                          ""
                                        )
                                        .toLowerCase()}${sub.name
                                        .trim()
                                        .replace(
                                          /\s+/g,
                                          ""
                                        )
                                        .toLowerCase()}.png`}
                                      alt=""
                                      className="wej-mobile-sub-icon"
                                    />

                                    <span>
                                      {sub.name}
                                    </span>

                                  </Link>
                                )
                              )}

                            </div>

                            {/* Shapes */}

                            {shapes.length >
                              0 && (
                              <div className="wej-mobile-subsection">

                                <div className="wej-mobile-subsection-title">
                                  Shop by Shape
                                </div>

                                {shapes.map(
                                  (shape) => (
                                    <Link
                                      key={
                                        shape.id
                                      }
                                      to={`/products?category=${encodeURIComponent(
                                        cat.categoryName
                                      )}&shape=${encodeURIComponent(
                                        shape.name
                                      )}`}
                                      className="wej-mobile-sub-link"
                                      onClick={
                                        closeMobileMenu
                                      }
                                    >

                                      <img
                                        src={`https://westendjewellery.com/assets/img/shape/${shape.name
                                          .trim()
                                          .replace(
                                            /\s+/g,
                                            ""
                                          )
                                          .toLowerCase()}.png`}
                                        alt=""
                                        className="wej-mobile-sub-icon"
                                      />

                                      <span>
                                        {shape.name}
                                      </span>

                                    </Link>
                                  )
                                )}

                              </div>
                            )}

                            {/* Diamonds */}

                            {diamonds.length >
                              0 && (
                              <div className="wej-mobile-subsection">

                                <div className="wej-mobile-subsection-title">
                                  Diamond Type
                                </div>

                                {diamonds.map(
                                  (
                                    diamond
                                  ) => (
                                    <Link
                                      key={
                                        diamond.id
                                      }
                                      to={`/products?category=${encodeURIComponent(
                                        cat.categoryName
                                      )}&diamond=${encodeURIComponent(
                                        diamond.name
                                      )}`}
                                      className="wej-mobile-sub-link"
                                      onClick={
                                        closeMobileMenu
                                      }
                                    >

                                      <img
                                        src="https://westendjewellery.com/assets/img/DIAMOND.png"
                                        alt=""
                                        className="wej-mobile-sub-icon wej-mobile-diamond-icon"
                                      />

                                      <span>
                                        {
                                          diamond.name
                                        }
                                      </span>

                                    </Link>
                                  )
                                )}

                              </div>
                            )}

                            {/* Metals */}

                            <div className="wej-mobile-subsection">

                              <div className="wej-mobile-subsection-title">
                                Metal Type
                              </div>

                              {metals.map(
                                (metal) => (
                                  <Link
                                    key={metal}
                                    to={`/products?category=${encodeURIComponent(
                                      cat.categoryName
                                    )}&metal=${encodeURIComponent(
                                      metal
                                    )}`}
                                    className="wej-mobile-sub-link"
                                    onClick={
                                      closeMobileMenu
                                    }
                                  >

                                    <img
                                      src={`https://westendjewellery.com/assets/img/${metal
                                        .replace(
                                          /\s+/g,
                                          ""
                                        )
                                        .toLowerCase()}.png`}
                                      alt=""
                                      className="wej-mobile-sub-icon"
                                    />

                                    <span>
                                      {metal}
                                    </span>

                                  </Link>
                                )
                              )}

                            </div>

                          </div>
                        </div>
                      )}

                    </div>
                  );
                })}

              {/* Dashboard */}

              <Link
                to="/partnerdashboard"
                className="wej-mobile-main-link"
                onClick={closeMobileMenu}
              >
                Dashboard
              </Link>

              {/* Stock */}

              <Link
                to="/stockandcarry"
                className="wej-mobile-main-link"
                onClick={closeMobileMenu}
              >
                Stock On Hand
              </Link>

              {/* About */}

              <Link
                to="/about"
                className="wej-mobile-main-link"
                onClick={closeMobileMenu}
              >
                About US
              </Link>

              {/* Login / Register */}

              {(!user ||
                Object.keys(user).length ===
                  0) && (
                <>
                  <Link
                    to="/Login"
                    className="wej-mobile-main-link"
                    onClick={closeMobileMenu}
                  >
                    Log In
                  </Link>

                  <Link
                    to="/registration"
                    className="wej-mobile-main-link"
                    onClick={closeMobileMenu}
                  >
                    Sign Up
                  </Link>
                </>
              )}

              {/* Logged-in Account */}

              {user && (
                <div className="wej-mobile-account-area">

                  <div className="wej-mobile-account-title">
                    Account
                  </div>

                  {/* Wholesale / Retail */}

                  <div className="wej-mobile-account-actions">

                    {(user?.customerType
                      ?.toLowerCase() ===
                      "wholesale" ||
                      user?.customerType
                        ?.toLowerCase() ===
                        "both") && (
                      <button
                        type="button"
                        className={`wej-mobile-view-button ${
                          active ===
                          "wholesale"
                            ? "wej-mobile-view-button-active"
                            : ""
                        }`}
                        onClick={() =>
                          handleViewChange(
                            "wholesale"
                          )
                        }
                      >
                        Wholesale
                      </button>
                    )}

                    {(user?.customerType
                      ?.toLowerCase() ===
                      "retail" ||
                      user?.customerType
                        ?.toLowerCase() ===
                        "both") && (
                      <button
                        type="button"
                        className={`wej-mobile-view-button ${
                          active === "retail"
                            ? "wej-mobile-view-button-active"
                            : ""
                        }`}
                        onClick={() =>
                          handleViewChange(
                            "retail"
                          )
                        }
                      >
                        Retail
                      </button>
                    )}

                  </div>

                  {/* Account Links */}

                  <div className="wej-mobile-account-links">

                    <div className="wej-mobile-currency">
                      <Currency />
                    </div>

                    <Link
                      to="/wishlist"
                      className="wej-mobile-account-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      Wishlist
                    </Link>

                    <Link
                      to="/cart"
                      className="wej-mobile-account-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      Cart
                    </Link>

                    <button
                      type="button"
                      className="wej-mobile-account-link wej-mobile-logout-button"
                      onClick={
                        handleLogout
                      }
                    >
                      Logout
                    </button>

                  </div>

                </div>
              )}

            </nav>

          </div>
        </div>

      </div>

      {/* ============================================================
          MOBILE NAVIGATION CSS
          All classes use unique "wej-mobile-" prefix
          ============================================================ */}

      <style>{`

        .wej-mobile-header {
          display: none;
          position: relative;
          width: 100%;
          z-index: 9999;
          background: #ffffff;
        }

        .wej-mobile-header-inner {
          min-height: 70px;
          padding: 10px 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 15px;
          border-bottom: 1px solid #eeeeee;
          box-sizing: border-box;
        }

        .wej-mobile-logo {
          display: flex;
          align-items: center;
          max-width: calc(100% - 65px);
        }

        .wej-mobile-logo img {
          display: block;
          width: auto;
          max-width: 210px;
          height: auto;
          max-height: 48px;
          object-fit: contain;
        }

        /* ============================================================
           HAMBURGER
           ============================================================ */

        .wej-mobile-menu-button {
          position: relative;
          flex: 0 0 44px;
          width: 44px;
          height: 44px;
          padding: 0;
          border: 1px solid #dddddd;
          border-radius: 5px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 5px;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
        }

        .wej-mobile-menu-button span {
          display: block;
          width: 21px;
          height: 2px;
          border-radius: 2px;
          background: #222222;
          transform-origin: center;
          transition:
            transform 0.28s ease,
            opacity 0.2s ease;
        }

        /* Hamburger -> X */

        .wej-mobile-menu-button-open
          span:nth-child(1) {
          transform:
            translateY(7px)
            rotate(45deg);
        }

        .wej-mobile-menu-button-open
          span:nth-child(2) {
          opacity: 0;
          transform: scaleX(0);
        }

        .wej-mobile-menu-button-open
          span:nth-child(3) {
          transform:
            translateY(-7px)
            rotate(-45deg);
        }

        /* ============================================================
           MOBILE DRAWER
           ============================================================ */

        .wej-mobile-drawer {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          max-height:
            calc(100vh - 70px);
          overflow: hidden;
          background: #ffffff;
          border-bottom:
            1px solid #e8e8e8;
          box-shadow:
            0 12px 30px
            rgba(0, 0, 0, 0.10);

          opacity: 0;
          visibility: hidden;
          transform:
            translateY(-12px);
          pointer-events: none;

          transition:
            opacity 0.28s ease,
            transform 0.32s ease,
            visibility 0.32s ease;
        }

        .wej-mobile-drawer-open {
          opacity: 1;
          visibility: visible;
          transform:
            translateY(0);
          pointer-events: auto;
        }

        .wej-mobile-drawer-scroll {
          max-height:
            calc(100vh - 70px);
          overflow-y: auto;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
        }

        .wej-mobile-nav {
          width: 100%;
          padding:
            6px 18px 24px;
          box-sizing: border-box;
        }

        /* ============================================================
           MAIN LINKS
           ============================================================ */

        .wej-mobile-main-link,
        .wej-mobile-category-row {
          min-height: 50px;
          box-sizing: border-box;
          border-bottom:
            1px solid #eeeeee;
        }

        .wej-mobile-main-link {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 13px 3px;
          color: #222222;
          text-decoration: none;
          font-size: 15px;
          font-weight: 500;
          letter-spacing: 0.15px;
          transition:
            color 0.2s ease,
            padding-left 0.2s ease;
        }

        .wej-mobile-main-link:hover {
          color: #777777;
          padding-left: 7px;
        }

        /* ============================================================
           CATEGORY ROW
           ============================================================ */

        .wej-mobile-category-row {
          display: flex;
          align-items: center;
        }

        .wej-mobile-category-link {
          flex: 1;
          min-width: 0;
          padding: 13px 3px;
          color: #222222;
          text-decoration: none;
          font-size: 15px;
          font-weight: 500;
          line-height: 1.35;
        }

        /* ============================================================
           CATEGORY + / -
           ============================================================ */

        .wej-mobile-category-toggle {
          flex: 0 0 42px;
          width: 42px;
          height: 42px;
          position: relative;
          border: 0;
          background: transparent;
          cursor: pointer;
        }

        .wej-mobile-category-toggle span {
          position: absolute;
          left: 12px;
          top: 20px;
          width: 17px;
          height: 1.5px;
          background: #333333;
          transition:
            transform 0.25s ease;
        }

        .wej-mobile-category-toggle
          span:nth-child(2) {
          transform:
            rotate(90deg);
        }

        .wej-mobile-category-open
          .wej-mobile-category-toggle
          span:nth-child(2) {
          transform:
            rotate(0deg);
        }

        /* ============================================================
           SUBMENU SMOOTH ANIMATION
           ============================================================ */

        .wej-mobile-submenu {
          display: grid;
          grid-template-rows: 0fr;
          transition:
            grid-template-rows 0.35s ease;
        }

        .wej-mobile-submenu-open {
          grid-template-rows: 1fr;
        }

        .wej-mobile-submenu-inner {
          min-height: 0;
          overflow: hidden;
          padding: 0 5px;
        }

        .wej-mobile-submenu-open
          .wej-mobile-submenu-inner {
          padding-top: 5px;
          padding-bottom: 10px;
        }

        /* ============================================================
           SUBSECTIONS
           ============================================================ */

        .wej-mobile-subsection {
          padding:
            8px 0 12px;
        }

        .wej-mobile-subsection-title {
          padding:
            6px 4px 9px;
          color: #777777;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }

        .wej-mobile-sub-link {
          min-height: 42px;
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 7px 8px;
          color: #333333;
          text-decoration: none;
          border-radius: 4px;
          font-size: 14px;
          line-height: 1.3;
          box-sizing: border-box;

          transition:
            background 0.2s ease,
            padding-left 0.2s ease;
        }

        .wej-mobile-sub-link:hover {
          background: #f7f7f7;
          padding-left: 12px;
        }

        .wej-mobile-sub-icon {
          flex:
            0 0 28px;
          width: 28px;
          height: 28px;
          object-fit: contain;
        }

        .wej-mobile-diamond-icon {
          width: 24px;
          height: 24px;
          margin-left: 2px;
          margin-right: 2px;
        }

        /* ============================================================
           ACCOUNT
           ============================================================ */

        .wej-mobile-account-area {
          margin-top: 16px;
          padding:
            16px 0 0;
          border-top:
            1px solid #e5e5e5;
        }

        .wej-mobile-account-title {
          margin-bottom: 10px;
          color: #777777;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }

        .wej-mobile-account-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 12px;
        }

        .wej-mobile-view-button {
          padding:
            8px 13px;
          border:
            1px solid #cccccc;
          border-radius: 4px;
          background: #ffffff;
          color: #333333;
          cursor: pointer;
          font-size: 13px;
        }

        .wej-mobile-view-button-active {
          background: #a0989821;
          border:
            2px solid #a0989821;
          font-weight: 700;
        }

        .wej-mobile-account-links {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .wej-mobile-currency {
          padding:
            2px 0 6px;
        }

        .wej-mobile-account-link {
          width: 100%;
          min-height: 42px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding:
            9px 12px;
          border:
            1px solid #dddddd;
          border-radius: 4px;
          background: #ffffff;
          color: #333333;
          text-decoration: none;
          font-size: 14px;
          cursor: pointer;
        }

        .wej-mobile-logout-button {
          justify-content:
            flex-start;
        }

        /* ============================================================
           TABLET + MOBILE
           ============================================================ */

        @media (max-width: 991px) {

          .wej-mobile-header {
            display: block;
          }

          .header-desktop {
            display: none !important;
          }

        }

        /* ============================================================
           DESKTOP
           ============================================================ */

        @media (min-width: 992px) {

          .wej-mobile-header {
            display: none !important;
          }

        }

        /* ============================================================
           SMALL PHONES
           ============================================================ */

        @media (max-width: 480px) {

          .wej-mobile-header-inner {
            min-height: 64px;
            padding:
              8px 14px;
          }

          .wej-mobile-drawer,
          .wej-mobile-drawer-scroll {
            max-height:
              calc(100vh - 64px);
          }

          .wej-mobile-logo img {
            max-width: 175px;
            max-height: 43px;
          }

          .wej-mobile-menu-button {
            flex-basis: 42px;
            width: 42px;
            height: 42px;
          }

          .wej-mobile-nav {
            padding-left: 14px;
            padding-right: 14px;
          }

        }

        /* ============================================================
           VERY SMALL DEVICES
           ============================================================ */

        @media (max-width: 360px) {

          .wej-mobile-header-inner {
            padding-left: 10px;
            padding-right: 10px;
          }

          .wej-mobile-logo img {
            max-width: 155px;
          }

          .wej-mobile-nav {
            padding-left: 10px;
            padding-right: 10px;
          }

          .wej-mobile-main-link,
          .wej-mobile-category-link {
            font-size: 14px;
          }

          .wej-mobile-sub-link {
            font-size: 13px;
          }

        }

        /* ============================================================
           REDUCED MOTION
           ============================================================ */

        @media (prefers-reduced-motion: reduce) {

          .wej-mobile-drawer,
          .wej-mobile-menu-button span,
          .wej-mobile-submenu,
          .wej-mobile-category-toggle span,
          .wej-mobile-main-link,
          .wej-mobile-sub-link {
            transition: none !important;
          }

        }

      `}</style>

    </header>
  );
};

export default Headerwithoutmenu;